import { FC } from 'react';
import { UseFormRegister, FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { PropertyFormData } from '@/types/index';
import { Input } from '@components/common/Input';
import { RadioGroup } from '@components/common/RadioGroup';

interface Step3SurfacesProps {
  register: UseFormRegister<PropertyFormData>;
  errors: FieldErrors<PropertyFormData>;
  setValue: UseFormSetValue<PropertyFormData>;
  watch: UseFormWatch<PropertyFormData>;
}

export const Step3Surfaces: FC<Step3SurfacesProps> = ({
  register,
  errors,
  setValue,
  watch,
}) => {
  const exteriorType = watch('exteriorType') || 'balcony';

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
        Surfaces
      </h2>

      {/* Section Surface principale */}
      <div className="space-y-4">
        <div className="flex items-end gap-4">
          <div className="flex-1">
            <Input
              label="Surface"
              type="number"
              {...register('area', {
                required: 'La surface est requise',
                valueAsNumber: true,
                min: { value: 1, message: 'La surface doit être au moins 1 m²' },
              })}
              error={errors.area?.message}
              required
              placeholder="98"
            />
          </div>
          <span className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3">
            m²
          </span>
        </div>

        <RadioGroup
          name="areaType"
          options={[
            { value: 'habitable', label: 'Surface habitable' },
            { value: 'weighted', label: 'Surface pondérée' },
          ]}
          value="habitable"
          onChange={() => {}}
          layout="horizontal"
        />
      </div>

      {/* Section Surfaces extérieures */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
          Surfaces extérieures
        </h3>

        <div className="flex items-end gap-4">
          <div className="flex-1">
            <Input
              label="Renseignez la surface"
              type="number"
              {...register('exteriorArea', {
                valueAsNumber: true,
                min: { value: 0, message: 'La surface doit être positive' },
              })}
              error={errors.exteriorArea?.message}
              placeholder="12"
            />
          </div>
          <span className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3">
            m²
          </span>
        </div>

        <RadioGroup
          name="exteriorType"
          options={[
            { value: 'balcony', label: 'Balcon' },
            { value: 'terrace', label: 'Terrasse' },
            { value: 'garden', label: 'Jardin' },
          ]}
          value={exteriorType}
          onChange={(value) => setValue('exteriorType', value)}
          layout="horizontal"
        />

        {/* Bouton + pour ajouter une surface additionnelle (v2) */}
        <div className="flex justify-center">
          <button
            type="button"
            className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            title="Ajouter une surface extérieure"
            disabled
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
          </button>
        </div>
        <p className="text-xs text-center text-gray-500 dark:text-gray-400">
          (Ajouter plusieurs surfaces extérieures - disponible prochainement)
        </p>
      </div>
    </div>
  );
};
